/* product matras start*/



/*size pick cards*/
const buttons11 = document.querySelectorAll('.vp-size-picker-btn');
let selected11 = null;

buttons11.forEach(btn => {
    btn.addEventListener('click', () => {
        buttons11.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        selected11 = btn.dataset.size;
    });
});
/*vp-size-bed-frame-btn*/
const buttonsframe11 = document.querySelectorAll('.vp-size-bed-frame-btn');
let selectedframe11 = null;

buttonsframe11.forEach(btn => {
    btn.addEventListener('click', () => {
        buttonsframe11.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        selectedframe11 = btn.dataset.size;
    });
});
/*size-more-bed*/
const buttonsbed11 = document.querySelectorAll('.vp-size-more-bed-btn');
let selectedbed11 = null;

buttonsbed11.forEach(btn => {
    btn.addEventListener('click', () => {
        buttonsbed11.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        selectedbed11 = btn.dataset.size;
    });
});

/* gallery*/
function changeImage(element) {
    document.getElementById("vp-mainImg").src = element.src;
}

var header = document.getElementsByClassName("vp-thumbnails")[0];
var imgs = document.getElementsByClassName("vp-thumbnails-img");
for (var i = 0; i < imgs.length; i++) {
    imgs[i].addEventListener("click", function () {
        var current = document.getElementsByClassName("vp-active");
        console.log(current.length);
        for (var k = 0; k < current.length; k++) {
            current[k].className = current[k].className.replace(" vp-active", "");

        }

        this.className += " vp-active";
    });
}


function selectCard(e) {
    console.log("Card clicked!");
}

// when click learn more
document.querySelectorAll('.vp-learn-more-div a').forEach(link => {
    link.addEventListener('click', e => {
        e.stopPropagation();
    });
});


/*product matras end*/


/* product slider start*/
var swiper = new Swiper(".vp-mySwiper-product-two", {
    slidesPerView: 1.1,
    spaceBetween: 16,
    navigation: {
        nextEl: ".swiper-button-next-two",
        prevEl: ".swiper-button-prev-two",
    },
    breakpoints: {
        500: {
            slidesPerView: 1.5
        },
        768: {
            slidesPerView: 2.3
        },
        998: {
            slidesPerView: 2.5,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 24
        }
    }
});
// product slider end


                /*accordion*/
                const accordionBtns = document.querySelectorAll(".vp-accordion-more-bed .vp-accordion");

                accordionBtns.forEach((accordion) => {
                    accordion.onclick = function () {
                        this.classList.toggle("vp-is-open");

                        let content = this.nextElementSibling;

                        if (content.style.maxHeight) {
                            //this is if the accordion is open
                            content.style.maxHeight = null;
                        } else {
                            //if the accordion is currently closed
                            content.style.maxHeight = content.scrollHeight + "px"; 
                        }
                    };
                });

                /* pairs best with*/
                const buttonspairs = document.querySelectorAll('.vp-pairs-best-btn');
                let selectedpairs = null;

                buttonspairs.forEach(btn => {
                    btn.addEventListener('click', () => {
                        buttonspairs.forEach(b => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        selectedpairs = btn.dataset.size;
                    });
                });

              

                /* gallery*/
                function changeImage(element) {
                    document.getElementById("vp-mainImg").src = element.src;
                }

                var header = document.getElementsByClassName("vp-thumbnails")[0];
                var imgs = document.getElementsByClassName("vp-thumbnails-img");
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].addEventListener("click", function () {
                        var current = document.getElementsByClassName("vp-active");
                        console.log(current.length);
                        for (var k = 0; k < current.length; k++) {
                            current[k].className = current[k].className.replace(" vp-active", "");

                        }

                        this.className += " vp-active";
                    });
                }


                // when click learn more
                document.querySelectorAll('.vp-learn-more-div a').forEach(link => {
                    link.addEventListener('click', e => {
                        e.stopPropagation();
                    });
                });